<script>
  import { page } from '$app/stores';

  export let user;
  export let mutualSuggestedFollow;
  export let suggestedFollow;
  export let code;

  let hasMutualSuggestedFollow = mutualSuggestedFollow && mutualSuggestedFollow.id;
  let hasSuggestedFollow = suggestedFollow && suggestedFollow !== '';
  let utmMedium = $page.url.searchParams.get('utm_medium');

  let useDefaultOgImage = utmMedium === 'scouted-outreach';

  let title = `${user && user.name} | Benable invite`;
  let description = `50k+ on waitlist. Skip the line.`;
  let ogImage = user && user.og_invite_url;
  let ogImageWidth = 600;
  let ogImageHeight = 960;

  if (hasMutualSuggestedFollow || hasSuggestedFollow) {
    let urlParams = Array.from($page.url.searchParams)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    title = user && user.name ? `${user.name} is inviting you!` : 'Benable - for influencers & all';
    ogImageHeight = 750;

    if (hasMutualSuggestedFollow) {
      const escapedUsername = mutualSuggestedFollow.username.replace(/\./g, '|');
      ogImage = `${import.meta.env['VITE_API_URL']}/og/images/ig_dm/${code}/${escapedUsername}.png?source=suggestion&${urlParams}`;
    } else {
      const escapedUsername = suggestedFollow.replace(/\./g, '|');
      ogImage = `${import.meta.env['VITE_API_URL']}/og/images/ig_dm/${code}/${escapedUsername}.png?source=search&${urlParams}`;
    }
  }

  if (useDefaultOgImage) {
    ogImageWidth = 1200;
    ogImageHeight = 628;
  }
</script>

<svelte:head>
  {#if user}
    <title>Shareable lists of things you recommend</title>
    <meta name="url" content="{import.meta.env['VITE_SITE_URL']}{user.profile_path}" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    {@html `<meta property="og:image" content="${ogImage}" />`}
    <meta property="og:image:width" content={ogImageWidth} />
    <meta property="og:image:height" content={ogImageHeight} />
    {@html `<meta property="twitter:image" content="${ogImage}" />`}
    <meta name="twitter:site" content="@Benable_HQ" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta property="og:type" content="website" />
    {@html `<meta property="og:video:url" content="${ogImage}" />`}
    <meta property="og:video:width" content={ogImageWidth} />
    <meta property="og:video:height" content={ogImageHeight} />
  {/if}
</svelte:head>
